// /src/toolkitServices/categoryApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const categoryApi = createApi({
  reducerPath: "categoryApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include",
  }),
  tagTypes: ["Category"],
  endpoints: (builder) => ({
    addCategory: builder.mutation({
      query: (data) => ({
        url: "/categories/create",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Category"],
    }),

    getAllCategories: builder.query({
      query: ({ page = 1, limit = 1000, search = "", active } = {}) => {
        const params = { page, limit, q: search };
        if (typeof active === "boolean") params.active = active;
        return { url: "/categories", params };
      },
      providesTags: ["Category"],
    }),

    // ⬇️ needed for Edit page
    getCategoryById: builder.query({
      query: (id) => `/categories/${id}`,
      providesTags: (_res, _err, id) => [{ type: "Category", id }],
    }),

    updateCategory: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `/categories/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: ["Category"],
    }),

    // optional: if you use toggle buttons in list
    activateCategory: builder.mutation({
      query: (id) => ({
        url: `/categories/${id}/activate`,
        method: "PATCH",
      }),
      invalidatesTags: ["Category"],
    }),
    deactivateCategory: builder.mutation({
      query: (id) => ({
        url: `/categories/${id}/deactivate`,
        method: "PATCH",
      }),
      invalidatesTags: ["Category"],
    }),
  }),
});

export const {
  useAddCategoryMutation,
  useGetAllCategoriesQuery,
  useGetCategoryByIdQuery,
  useUpdateCategoryMutation,
  useActivateCategoryMutation,
  useDeactivateCategoryMutation,
} = categoryApi;

export default categoryApi;
